import config from "../app-config";
import serverFetch from "../utils/serverFetch";

export const fetch_all_bulletin = async () => {
    return await serverFetch({
        endpoint: `${config.endpoint}/bulletin/`,
        method: "GET",
        credentials: "include"
    });
}

export const fetch_bulletin_by_id = async (bulletin_id) => {
    if (!bulletin_id) return { error: "No bulletin id provided" };
    return await serverFetch({
        endpoint: `${config.endpoint}/bulletin/id/${bulletin_id}`,
        method: "GET",
        credentials: "include"
    });
}

export const create_new_bulletin = async (bulletin_data) => {
    return await serverFetch({
        endpoint: `${config.endpoint}/bulletin/`,
        method: "POST",
        body: JSON.stringify(bulletin_data),
        credentials: "include"
    });
}

export const update_bulletin_by_id = async (bulletin_id, bulletin_data) => {
    if (!bulletin_id) return { error: "No bulletin id provided" };
    return await serverFetch({
        endpoint: `${config.endpoint}/bulletin/id/${bulletin_id}`,
        method: "PUT",
        body: JSON.stringify(bulletin_data),
        credentials: "include"
    });
}

export const delete_bulletin_by_id = async (bulletin_id) => {
    if (!bulletin_id) return { error: "No bulletin id provided" };
    return await serverFetch({
        endpoint: `${config.endpoint}/bulletin/id/${bulletin_id}`,
        method: "DELETE",
        credentials: "include"
    });
}
